import React from 'react';
//import MeetingsStore from '../igmeetings_components/stores/MeetingsStore.js';
//import IgBusinessStore from './stores/IgBusinessStore';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
//import Meeting from '../igmeetings_components/Meeting';
import {
  Row,
  Col,
  Panel,
  Glyphicon,
  Button,
  ButtonToolbar
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Activity from './Activity';
import ButtonWithConfirmation from '../common_components/ButtonWithConfirmation';
import { SECTIONS } from './constantsTooltips';
//import pdfMake from 'pdfmake/build/pdfmake';
//import vfsFonts from 'pdfmake/build/vfs_fonts'
// import {AUTH_EDIT, AUTH_SHOW} from './authorization';

@injectIntl
@inject('rootStore')
@observer
export default class ActivityShow extends React.Component {
  constructor(props) {
    super(props);

    this.printDocument = this.printDocument.bind(this);
    this.handleActivityTemplateClick = this.handleActivityTemplateClick.bind(
      this
    );
  }

  componentWillMount() {
    const { rootStore } = this.props;

    rootStore.tooltipStore.setCurrentSection('');
  }

  render() {
    const activityId = this.props.match.params.id;
    const activity = this.props.rootStore.activityStore.getActivityById(
      activityId
    );
    const { intl, rootStore } = this.props;
    const backButton = (
      <LinkContainer to={this.props.rootStore.initialPath}>
        <Button bsStyle="default">
          <Glyphicon glyph="arrow-left" />
          &nbsp; {intl.formatMessage({ id: 'back' })}
        </Button>
      </LinkContainer>
    );

    if (!activity) {
      return (
        <div className="not-found-error">
          {intl.formatMessage({ id: 'activity_not_found' })}
          <br />
          {backButton}
        </div>
      );
    }

    rootStore.tooltipStore.setCurrentSection(SECTIONS.show);

    return (
      <div>
        <Row>
          <Col xs={12}>
            <Panel className="border-top-6">
              <div id={'activity'}>
                <Activity id={'activity'} activity={activity} />
              </div>
            </Panel>
          </Col>
        </Row>

        <ButtonToolbar id="activity-buttons" style={{ marginBottom: '15px' }}>
          {backButton}
          {rootStore.authorizationStore.authEdit(EditButton, true, {
            activity: activity
          })}
          <Button onClick={this.printDocument}>
            <Glyphicon glyph="file" />
            {intl.formatMessage({ id: 'generate_pdf' })}
          </Button>
          {rootStore.authorizationStore.authEdit(ActivityTemplateButton, true, {
            onClick: this.handleActivityTemplateClick
          })}
          {rootStore.authorizationStore.authEdit(DeleteButton, true, {
            onDelete: () => this.handleDelete(activity)
          })}
        </ButtonToolbar>
      </div>
    );
  }

  handleDelete(activity) {
    activity.destroy();
    this.props.history.push(this.props.rootStore.initialPath);
  }

  handleActivityTemplateClick() {
    const activityId = this.props.match.params.id;
    const activity = this.props.rootStore.activityStore.getActivityById(
      activityId
    );
    this.props.rootStore.activityStore.loadActivityAsTemplate(activity);
  }

  printDocument() {
    import('imports-loader?this=>window!pdfmake/build/vfs_fonts').then(vfsFonts => {
      import('pdfmake/build/pdfmake.min').then(pdfMake => {
        const { intl } = this.props;
        pdfMake.vfs = vfsFonts.pdfMake ? vfsFonts.pdfMake.vfs : pdfMake.vfs;

        const activityId = this.props.match.params.id;
        const activity = this.props.rootStore.activityStore.getActivityById(
          activityId
        );

        var docDefinition = {
          header: {
            text:
              'IGNIS GRAVITAS ' +
              intl.formatMessage({ id: 'igbusiness' }) +
              ' ' +
              new Date().getFullYear(),
            style: 'header'
          },
          content: [],
          styles: {
            fontSize: 13,
            header: {
              fontSize: 12,
              bold: true,
              color: '#777',
              margin: [20, 30, 20, 20],
              alignment: 'center'
            },
            subheader: {
              color: '#222',
              fontSize: 12,
              bold: true,
              margin: [0, 25, 0, 5]
            },
            itemDetails: {
              italic: true,
              alignment: 'justified'
            },
            itemName: {
              bold: true,
              alignment: 'justified'
            }
          },
          defaultStyle: {
            fontSize: 11,
            color: '#333',
            lineHeight: 1.3,
            alignment: 'justified'
          },
          pageMargins: [60, 60, 50, 60],
          pageSize: 'LETTER'
        };

        const activityName = activity.activityName;
        const specificName = activity.name;
        if (activityName) {
          docDefinition.content.push({
            text: intl.formatMessage({ id: 'name' }),
            style: 'subheader'
          });
          docDefinition.content.push({ text: activityName });
        }

        if (specificName) {
          docDefinition.content.push({
            text: intl.formatMessage({ id: 'specific_name' }),
            style: 'subheader'
          });
          docDefinition.content.push({ text: specificName });
        }

        // Description
        const description = activity.activityDescription;
        if (description) {
          docDefinition.content.push({
            text: intl.formatMessage({ id: 'description' }),
            style: 'subheader'
          });
          docDefinition.content.push({ text: description });
        }

        // Additional information
        const customDescription = activity.customDescription;
        if (customDescription) {
          docDefinition.content.push({
            text: intl.formatMessage({ id: 'additional_information' }),
            style: 'subheader'
          }),
            docDefinition.content.push({ text: customDescription });
        }

        // Location
        if (activity.place) {
          docDefinition.content.push({
            text: intl.formatMessage({ id: 'location' }),
            style: 'subheader'
          });
          docDefinition.content.push({ text: activity.place });
        }

        // Date
        let dateColumns = [
          {
            width: '50%',
            text: intl.formatMessage({ id: 'start_date' }),
            style: 'subheader'
          },
          {
            width: '50%',
            text: intl.formatMessage({ id: 'finish_date' }),
            style: 'subheader'
          }
        ];
        docDefinition.content.push({ columns: dateColumns });
        dateColumns = [
          {
            width: '50%',
            text:
              intl.formatDate(activity.startDate) +
              ' ' +
              intl.formatTime(activity.startDate)
          },
          {
            width: '50%',
            text:
              intl.formatDate(activity.finishDate) +
              ' ' +
              intl.formatTime(activity.finishDate)
          }
        ];
        docDefinition.content.push({ columns: dateColumns });

        // Goals
        let cards = activity.goals;
        addBmcItemsToDocument(
          cards,
          docDefinition,
          intl.formatMessage({ id: 'goals' })
        );

        // Measures
        let leanCards = activity.measure;
        addLeanItemsToDocument(
          leanCards,
          docDefinition,
          intl.formatMessage({ id: 'measure' })
        );

        // Offers
        cards = activity.offers;
        addBmcItemsToDocument(
          cards,
          docDefinition,
          intl.formatMessage({ id: 'offers' })
        );

        // Customers
        cards = activity.customers;
        addBmcItemsToDocument(
          cards,
          docDefinition,
          intl.formatMessage({ id: 'customers' })
        );

        // Invitation
        cards = activity.invitation;
        addBmcItemsToDocument(
          cards,
          docDefinition,
          intl.formatMessage({ id: 'invitation' })
        );

        // Connection
        cards = activity.connection;
        addBmcItemsToDocument(
          cards,
          docDefinition,
          intl.formatMessage({ id: 'connection' })
        );

        // Resources
        cards = activity.resources;
        addBmcItemsToDocument(
          cards,
          docDefinition,
          intl.formatMessage({ id: 'resources' })
        );

        // Partners
        cards = activity.partners;
        addBmcItemsToDocument(
          cards,
          docDefinition,
          intl.formatMessage({ id: 'partners' })
        );

        // Cost structure
        cards = activity.costStructure;
        addBmcItemsToDocument(
          cards,
          docDefinition,
          intl.formatMessage({ id: 'cost_structure' })
        );

        // Detailed costs
        const costs = activity.costs;
        if (costs.length > 0) {
          docDefinition.content.push({
            text: intl.formatMessage({ id: 'detailed_costs' }),
            style: 'subheader'
          });
          let items = [];
          for (let cost of costs) {
            items.push(cost.description + ': ' + cost.value);
          }
          docDefinition.content.push({ ul: items });
        }

        // Learn
        leanCards = activity.learn;
        addLeanItemsToDocument(
          leanCards,
          docDefinition,
          intl.formatMessage({ id: 'learn' })
        );

        // Build
        leanCards = activity.build;
        addLeanItemsToDocument(
          leanCards,
          docDefinition,
          intl.formatMessage({ id: 'build' })
        );

        function addBmcItemsToDocument(cards, docDefinition, title) {
          if (cards.length > 0) {
            let items = [];
            docDefinition.content.push({ text: title, style: 'subheader' });
            for (let card of cards) {
              let details = activity.getDetails(card.id);
              items.push({
                text: [
                  { text: card.name + ': ', style: 'itemName' },
                  { text: card.description + ' ' },
                  { text: '(' + details + ')', style: 'itemDetails' }
                ],
                alignment: 'justified'
              });
            }
            docDefinition.content.push({ ul: items });
          }
        }

        function addLeanItemsToDocument(leanCards, docDefinition, title) {
          if (leanCards.length > 0) {
            docDefinition.content.push({ text: title, style: 'subheader' });
            let items = [];
            for (let m of leanCards) {
              items.push(m.description);
            }
            docDefinition.content.push({ ul: items });
          }
        }

        pdfMake.createPdf(docDefinition).open();
      });
    });
  }
}

@injectIntl
@inject('rootStore')
class EditButton extends React.Component {
  render() {
    const { intl, activity } = this.props;
    return (
      <LinkContainer to={this.props.rootStore.getEditPath(activity.id)}>
        <Button bsStyle="default">
          <Glyphicon glyph="pencil" />
          &nbsp; {intl.formatMessage({ id: 'edit' })}
        </Button>
      </LinkContainer>
    );
  }
}

@injectIntl
@inject('rootStore')
class DeleteButton extends React.Component {
  render() {
    const { intl } = this.props;
    return (
      <ButtonWithConfirmation
        confirmationMessage={intl.formatMessage({
          id: 'delete_confirmation_msg'
        })}
        option1Label={intl.formatMessage({ id: 'delete_confirmation_no' })}
        option2Label={intl.formatMessage({ id: 'delete_confirmation_yes' })}
        onOption2Select={() => this.props.onDelete(activity)}
        dropup
      >
        <Glyphicon glyph="trash" />
        &nbsp; {intl.formatMessage({ id: 'delete' })}
      </ButtonWithConfirmation>
    );
  }
}

@injectIntl
@inject('rootStore')
class ActivityTemplateButton extends React.Component {
  render() {
    const { intl } = this.props;
    return (
      <LinkContainer to={this.props.rootStore.newActivityPath}>
        <Button bsStyle="default" onClick={this.props.onClick}>
          <i className="fa fa-copy" />
          &nbsp; {intl.formatMessage({ id: 'copy_activity' })}
        </Button>
      </LinkContainer>
    );
  }
}
